import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
    title: getTitle('Sign in'),
  },
  {
    path: 'token',
    loadComponent: () =>
      import('./token/token.component').then((m) => m.TokenComponent),
    title: getTitle('Token'),
  },
  {
    path: 'google',
    loadComponent: () =>
      import('./oauth-callback/oauth-callback.component').then(
        (m) => m.OAuthCallbackComponent
      ),
    data: { provider: 'google' },
    title: getTitle('Google'),
  },
  {
    path: 'microsoft',
    loadComponent: () =>
      import('./oauth-callback/oauth-callback.component').then(
        (m) => m.OAuthCallbackComponent
      ),
    data: { provider: 'microsoft' },
    title: getTitle('Microsoft'),
  },
  {
    path: 'logout',
    loadComponent: () =>
      import('./logout/logout.component').then((m) => m.LogoutComponent),
    title: getTitle('Logout'),
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./error/error.component').then((m) => m.ErrorComponent),
    title: getTitle('Error'),
  },
  // Catches any stale link to a route this app no longer serves (e.g. the
  // retired /consent route) so an in-flight browser lands on the error
  // screen instead of a blank, unmatched-route page during rollout.
  {
    path: '**',
    redirectTo: 'error',
  },
];

function getTitle(name?: string): string {
  const base = 'Human Made Machine';
  if (!name) {
    return base;
  }
  return `${name} | ${base}`;
}
